<template>
  <!-- Country -->
  <div class="form-group focused">
    <div class="custom-selectt">
      <label for="country">{{ props.label }}</label>
      <select id="country" v-model="country" class="form-control shipping-country crs-country" @blur="onBlur"
        @focus="onFocus" @change="emit('change', country)" data-region-id="state" data-value="shortcode"
        :data-default-value="country" autocomplete="country-name" />
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { onBlur, onFocus } from './fields.js'

const props = defineProps({
  label: String,
  defaultValue: String
})

const emit = defineEmits(['change'])
const country = ref((props.defaultValue != null) ? props.defaultValue : window.countryCode)

if (props?.defaultValue) {
  emit('change', props?.defaultValue)
}

nextTick(() => {
  emit('change', country.value)
})
</script>
